import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 mt-2">娱乐圈最新爆料实时追踪</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-0">
            {updates.map((item) => (
              <article key={item.id} className="relative flex gap-5 pb-8 last:pb-0">
                <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-background-50 border-2 border-primary-200 flex items-center justify-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span
                      className={`px-2 py-0.5 text-xs font-semibold text-white rounded-md ${item.tagColor} whitespace-nowrap`}
                    >
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                    {item.title}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}